import { createContext, useContext } from 'react';
import type { DataSources } from '@losan/core';

const SourcesContext = createContext<DataSources | null>(null);

export const SourcesProvider = SourcesContext.Provider;

export function useSources(): DataSources {
  const ctx = useContext(SourcesContext);
  if (!ctx) throw new Error('useSources must be used inside <SourcesProvider>');
  return ctx;
}
